/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var DepSubsidiaryDashboardView = require('../views/DepSubsidiaryDashboardView');
var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetEntityDocMgmtDetails = require('../../common/services/GetEntityDocMgmtDetails');
var GetSubsidiary = require('../services/GetSubsidiary');

module.exports = function(entityId, subsidiaryId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetSubsidiary(subsidiaryId), GetEntityIdentifiers(entityId), GetEntityDocMgmtDetails(entityId))
    .done(function(subsidiary, entityIdentifiers, docMgmt) {
      NavUtils.navigate('dep/entity/' + entityId + '/subsidiary/' + subsidiaryId + '/dashboard');
      Scaffold.content.show(
        new DepSubsidiaryDashboardView({
          viewMode: 'int',
          model: new Backbone.Model({
            entityId: entityId,
            entityIdentifiers: entityIdentifiers,
            subsidiaryId: subsidiaryId,
            subsidiary: subsidiary,
            subsidiariesCSFolderId: docMgmt.subsidiariesCSFolderId
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
